import $http from '@Config/axios';

const prefix = 'comissao';

export default {
  getComissao(venda_id) {
    return new Promise((resolve, reject) => {
      $http.get(`${prefix}/${venda_id}`)
        .then(response => {
          resolve(response);
        })
        .catch(response => reject(response));
    });
  },
  getProfissionaisAssociados(venda_id) {
    return new Promise((resolve, reject) => {
      $http.get(`${prefix}/${venda_id}/profissionais`)
        .then(response => {
          resolve(response);
        })
        .catch(response => reject(response));
    });
  },
  storeManyComissoes(venda_id, params) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/${venda_id}/`, params)
        .then(response => resolve(response))
        .catch(response => reject(response));
    });
  }
};
